import React, { useState } from "react";
import { Avatar, Popover } from "antd";
import { momentit } from "../../utils";
import { ReactComponent as ViewIcon } from "../../Icons/totalView.svg";
import { useSelector } from "react-redux";
import { ReactComponent as InternalIcon } from "../../Icons/internal.svg";
import { ReactComponent as DownloadIcon } from "../../Icons/download.svg";
import Button2 from "../../NewComponent/Button2/Button2";
import AttachmentBox from "../../NewComponent/AttachmentBox/AttachmentBox";
import TooltipComp from '../../NewComponent/ToolTip/TooltipComp';
import { ReactComponent as StarIcon } from "../../Icons/darkstar.svg";
import { curationStatus } from "../../Constants";
import { useLocation } from "react-router-dom";
// import { ReactComponent as lock } from "../../../Icons/";

export default function NameInfo({ data, question }) {
  const currentPath = useLocation();
  
  const expertAnsweredState = useSelector((state) => state.answeredQuestions);
  const searchState = useSelector((state) => state.search);
  const userState = useSelector((state) => state.user);
  const onCLickFavorite = () => {
  };
  const userProfile = () => {
    let img = "";
    img = searchState.usersProfilePicData.find(
      (obj) => obj.uuid === data.expertUuid
    );

    if (img !== undefined&&img.img !== null) {
      return `data:image/JPEG;base64,${img.img}`;
    }
  };
  userProfile();
  const infoContainer = {
    display: "flex",
    alignItems: "center",
  };
  const dateInfoStyles = {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    paddingLeft: "7px",
  };
  const textStyles = {
    fontSize: "16px",
    color: "#2A364A",
    lineHeight: "24px",
    fontWeight: "500",
    wordBreak: 'break-word',overflowWrap: 'break-word',
  };
  const dateStyles = {
    fontSize: "13px",
    color: "#5C667B",
    lineHeight: "20px",
    fontWeight: "300",
  };

  const renderAttachemnt = (arr) => {
    return (
      <div>
        {arr.map((item, index) => (
          <div className="mb-1">
            {" "}
            <AttachmentBox key={index} attachment={item} />
          </div>
        ))}
      </div>
    );
  };


  const getGradient = (category) => {
    switch (category) {
      case 1:
        return 'linear-gradient(90.39deg, #ff7875 0.34%, #ff4d4f 99.7%)'; // red shades (updated sequence)
      case 2:
        return 'linear-gradient(90.39deg, #ffa940 0.34%, #fa8c16 99.7%)'; // orange shades
      default:
        return 'linear-gradient(90.39deg, #46c93a 0.34%, #2aa000 99.7%)'; // improved green shades
    }
  };
  
  
  const styles = {
    borderRadius: '6px',
    height: '24px',
    padding: '1px 8px',
    color: '#fff',
    textAlign: 'center',
    background: getGradient(data.curationCategory),
    fontSize: '13px',
    // marginLeft: '5px',
    fontWeight: '300',
    display: 'flex',
    alignItems: 'center',
    // cursor: onClickFunc === undefined ? "auto" : "pointer"
  };
  // console.log("data",data)
  return (
    <>
      <div style={infoContainer}>
        <div>
          <Avatar
            size={48}
            //   src={userProfile() || require("../../../Images/cliente.png")}
            src={userProfile() || require("../../Images/cliente.png")}
          ></Avatar>
          {/* {question.askSource === "expertqa" && (
            <Avatar
              size={48}
              src={userProfile() || require("../../../Images/cliente.png")}
            ></Avatar>
          )}
          {question.askSource !== "expertqa" && (
            <Avatar
              size={48}
              src={require("../../../Images/bot-icon.png")}
            ></Avatar>
          )} */}
        </div>
        <div style={dateInfoStyles}>
          <div>
            {/* {question.docType === "expertqa" && (
              <div style={textStyles}>
                {data.expert.firstName} {data.expert.lastName}&nbsp;<span style={{fontSize:'16px'}}><StarIcon style={{marginBottom:'6px'}} />&nbsp;{Math.round(data.expertScore)}<span style={{fontWeight:'300'}}>/10</span></span>
              </div>
            )}
            {question.docType !== "expertqa" && (
              <div style={textStyles}>
                {question.docName === "" || question.docName === undefined
                  ? `${data.expert.firstName} ${data.expert.lastName}`
                  : question.docName}
              </div>
            )} */}
            <div style={textStyles}>
              {data.expertFirstName} {data.expertLastName}&nbsp;
              {
                data.expertScore !== undefined && <span style={{ fontSize: '16px' }}>
                  <StarIcon style={{ marginBottom: '6px' }} />&nbsp;{Math.round(data?.expertScore)}<span style={{ fontWeight: '300' }}>/10</span></span>
              }
              {/* <span style={{fontSize:'16px'}}><StarIcon style={{marginBottom:'6px'}} />&nbsp;{Math.round(data.expertScore)}<span style={{fontWeight:'300'}}>/10</span></span> */}
            </div>
            <div style={dateStyles}>
              {data.answeredTimestamp < data.answerUpdatedTimestamp
                ? "Last reviewed"
                : "Answered"}
              &nbsp;
              {momentit(
                data.answeredTimestamp < data.answerUpdatedTimestamp
                  ? data.answerUpdatedTimestamp
                  : data.answeredTimestamp
              )}

            </div>
          </div>
          {/* Needs Curation-{curationStatus[data.curationCategory - 1]} */}
        
            
          {/* </TooltipComp> */}
          <div style={infoContainer}>
          
            {data.popularityScore !== null &&
              data.popularityScore !== undefined && (
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    fontSize: "14px",
                    lineHeight: "24px",
                    color: "#5C667B",
                    fontWeight: "500",
                  }}
                >
                  <ViewIcon />
                  &nbsp;{data.popularityScore}&nbsp;&nbsp;
                </span>
              )}
           {userState.geoAttributes.userId === data.expertUuid && data.curationStatus==="pending"&&data.curationCategory!==undefined&& currentPath.pathname.includes('/expertHome/answered')  && 
            //  <TooltipComp title={` ${curationStatus[data.curationCategory - 1]}`} >
              <span
              style={{
                  marginRight:"2px"
              }}>
              <div style={styles} >{curationStatus[data.curationCategory - 1]} </div>
              {/* <span style={{
                borderRadius: '3px',
                backgroundColor: `${data.curationCategory === 1 ? 'red' : data.curationCategory === 2 ? 'orange' : 'green'}`,
                color: '#fff',
                fontSize: '10px',
                padding: '4px',
                fontWeight: '600',
              }}>
                Needs Curation-{curationStatus[data.curationCategory - 1]}
              </span> */}
            </span>
            // </TooltipComp> 
            }
    
            {data.internal && (
              <TooltipComp title={"Internal"}>


                <div style={{ marginRight: "6px" }}>
                  <InternalIcon />
                </div>
              </TooltipComp>
            )}
            {
              data.privacy && (
                <TooltipComp title={"Privacy"}>


                  <div style={{ marginRight: "6px", marginLeft: "6px" }}>
                    {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="currentColor" width="16" height="18">
                    <path d="M400 224h-24v-72C376 68.1 307.9 0 224 0S72 68.1 72 152v72H48C21.5 224 0 245.5 0 272v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zm-80 0H128v-72c0-52.9 43.1-96 96-96s96 43.1 96 96v72z" />
                  </svg> */}
                    <i className="fa fa-lock" style={{
                      display: "flex",
                      alignItems: "center",
                      fontSize: "20px",
                      lineHeight: "24px",
                      color: "#5C667B",
                      fontWeight: "500",
                    }}></i>
                  </div>
                </TooltipComp>
              )
            }

            {
              data.attachments &&
              data.attachments.length > 0 && (
                <div style={{ paddingLeft: "5px" }}>
                  <Popover title={renderAttachemnt(data.attachments)}>
                    {" "}
                    <Button2 onClickFunc={onCLickFavorite}>
                      <DownloadIcon />
                    </Button2>
                  </Popover>
                </div>
              )}
            {/* {!data.userInitiatedCuration &&
                    data.expert.userUuidStr !==
                      userState.geoAttributes.userId &&
                      data.curationCategory === 1 &&
                        data.curationStatus === "pending" &&<div><TooltipComp title={'Recommended request for update; this answer may not be up-to-date.'}><span><i class="fa fa-exclamation-circle" style={{fontSize:'22px', color:'#F59B00', marginLeft:'5px'}}></i></span></TooltipComp>
              </div>} */}
          </div>
        </div>
      </div>
    </>
  );
}
